import ManualVolumeTable from "./components/ManualFuelVolumeTable";

const FuelVolume = () => {
  return (
    <>
      <>
        <ManualVolumeTable />
      </>
    </>
  );
};

export default FuelVolume;
